/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import { useEffect, useRef } from "react";

export default function GalaxyBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d", { alpha: true });
    let raf = 0;
    let stars = [];
    let reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      canvas.style.width = `${window.innerWidth}px`;
      canvas.style.height = `${window.innerHeight}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      const count = Math.min(140, Math.floor((window.innerWidth * window.innerHeight) / 14000));
      stars = Array.from({ length: count }, () => ({
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        r: Math.random() * 1.4 + 0.2,
        a: Math.random() * 0.7 + 0.2,
        s: Math.random() * 0.35 + 0.05,
        tw: Math.random() * Math.PI * 2,
      }));
    };

    const draw = (t) => {
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      for (const star of stars) {
        const twinkle = reduced ? star.a : star.a * (0.55 + 0.45 * Math.sin(t * 0.0015 + star.tw));
        ctx.beginPath();
        ctx.fillStyle = `rgba(187, 223, 249, ${twinkle})`;
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fill();
        if (!reduced) {
          star.y += star.s * 0.15;
          if (star.y > window.innerHeight) {
            star.y = 0;
            star.x = Math.random() * window.innerWidth;
          }
        }
      }
      if (!reduced) raf = requestAnimationFrame(draw);
    };

    resize();
    draw(0);
    window.addEventListener("resize", resize);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div className="gl-cosmos" aria-hidden="true">
      <div className="gl-cosmos__aurora" />
      <div className="gl-cosmos__orbit gl-cosmos__orbit--1" />
      <div className="gl-cosmos__orbit gl-cosmos__orbit--2" />
      <canvas ref={canvasRef} className="gl-cosmos__canvas" />
    </div>
  );
}
